module.exports = {
};



//////////////////
// WEBPACK FOOTER
// ./cfg/slot-config.js
// module id = 22
// module chunks = 0